import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanTodoSchema } from './shapes';

export const updatePlanTodo = defineEndpoint({
  method: 'PATCH',
  path: '/v1/release-plans/:planId/todos/:todoId',
  params: z.object({ planId: z.string().uuid(), todoId: z.string().uuid() }),
  query: z.object({}),
  body: z
    .object({
      completed: z.boolean(),
      assigneeUserId: z.string().uuid().nullable(),
      title: z.string().trim().min(1).max(300),
    })
    .partial(),
  response: z.object({ data: PlanTodoSchema }),
});
